export default {
  namespaced: true,
  state: {
    lastVerifiedPhone: null
  },
  actions: {
    setLastVerifiedPhone(context, phone) {
      context.state.lastVerifiedPhone = phone
    }
  }
}
